import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

export type DNDState = 'drag_over' | 'drag_leave';

export interface DragAndDropData {
  files: File[];
  pasteItem?: DataTransferItem;
  source: 'clipboard' | 'drag';
}

@UntilDestroy()
@Component({
  selector: 'drag-and-drop',
  templateUrl: './drag-and-drop.component.html',
  styleUrl: './drag-and-drop.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DragAndDropComponent {
  private dragCounter = 0;

  isDragging = false;

  disabled = input<boolean>();
  disabledPaste = input<boolean>();

  fileAdded = output<DragAndDropData>();

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDragEnter(event: DragEvent) {
    event.preventDefault();
    if (this.disabled()) {
      return;
    }
    this.dragCounter++;
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.dragCounter--;
    if (this.dragCounter === 0) {
      this.isDragging = false;
    }
  }

  onPaste(event: ClipboardEvent) {
    if (this.disabled() || this.disabledPaste()) {
      return;
    }
    const files = Array.from(event.clipboardData.files);
    const pasteItem = Array.from(event.clipboardData.items)?.filter((item) => item.kind !== 'file')?.[0];
    this.fileAdded.emit({ files, pasteItem, source: 'clipboard' });
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    if (this.disabled()) {
      return;
    }
    this.isDragging = false;
    this.dragCounter = 0;
    this.fileAdded.emit({ files: Array.from(event.dataTransfer.files), source: 'drag' });
  }
}
